import React from "react";
import "./pricing.css";

const features = [
  "Löpande bokföring",
  "Momsdeklarationer",
  "Lönehantering för 1 anställd",
  "Support via telefon och e-post",
  "Trygg och fast månadskostnad",
];

const AccountingPackage = () => (
  <section className="thas-pricing-intro" aria-labelledby="pricing-heading">
    <div className="thas-pricing-container thas-pricing-intro-grid">
      <div>
        <p className="thas-pricing-eyebrow">Fasta bokföringspaket</p>
        <h2 id="pricing-heading" className="thas-pricing-heading">
          Tydliga priser.<br />
          Tryggare vardag.
        </h2>
        <p className="thas-pricing-copy">
          Välj ett paket efter antalet verifikationer och få en fast
          månadskostnad. Du kan när som helst byta paket när dina behov ändras.
        </p>
        <p className="thas-pricing-note">Samtliga priser anges i SEK exkl. moms.</p>
      </div>
      <div className="thas-pricing-inclusions">
        <h3>Det här ingår i varje paket</h3>
        <ul>
          {features.map((feature) => (
            <li key={feature}>
              <span className="thas-pricing-check" aria-hidden="true">✓</span>
              {feature}
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default AccountingPackage;
